import { gql } from '@apollo/client'
import GolferProfileFragment from 'fragments/student/golferProfile'

const GET_STUDENTS_AND_INVITED_GUARDIANS = gql`
  ${GolferProfileFragment}
  query GetStudentsAndInvitedGuardians {
    currentUser {
      attributes {
        ... on Contact {
          jrlPlayers {
            id
          }
        }
      }
      representatives {
        relationshipType
        student {
          id
          firstName
          lastName
          isMinor
          golferProfile {
            ...GolferProfileAttributes
          }
          contact {
            email
            phone
          }
        }
      }
    }
    jrlGuardianInvitations {
      id
      status
      inviteName
      inviteEmail
      expiresAt
      canAccept
    }
  }
`

const INVITE_GUARDIAN = gql`
  mutation InviteGuardian($input: JRLInviteGuardianInput!) {
    inviteJrlGuardian(input: $input) {
      success
      message
    }
  }
`

const REVOKE_GUARDIAN_INVITATION = gql`
  mutation RevokeJrlGuardianInvitation($invitationId: ID!) {
    revokeJrlGuardianInvitation(invitationId: $invitationId) {
      success
      message
    }
  }
`

export {
  GET_STUDENTS_AND_INVITED_GUARDIANS,
  INVITE_GUARDIAN,
  REVOKE_GUARDIAN_INVITATION,
}
